import * as request from 'superagent'

function QaLogger(this: { init: (target: any) => void }) {
  let counter: number = 0

  class Internal {
    private isLoggerOn: boolean = true
    private Store: Array<any> = []

    public countActiveRequests = (): number => this.Store.length

    public resetQANetworkLogger = (): void => {
      this.Store = []
    }

    public turnOn = (): void => {
      this.isLoggerOn = true
    }

    public turnOff = (): void => {
      this.isLoggerOn = false
    }

    public getRequestWrapper = () => (
      req: request.SuperAgentRequest
    ): request.SuperAgentRequest => {
      return req.on('request', currentReq => {
        if (!this.isLoggerOn) {
          return
        }

        const { url, method } = currentReq
        const uid = `req_${counter++}`

        this.Store.unshift({
          uid,
          url,
          method,
          timestamp: Date.now()
        })

        const cleanStack = () => {
          this.Store = this.Store.filter(reqRecord => reqRecord.uid !== uid)
        }

        currentReq.on('close', cleanStack)
        currentReq.on('end', cleanStack)
        // currentReq.on( 'redirect', cleanStack ) // @todo: Uncomment this if necessary, remove it otherwise
        currentReq.on('error', cleanStack)
        currentReq.on('abort', cleanStack)
        currentReq.on('response', cleanStack)
      })
    }
  }

  this.init = target => {
    if (typeof target === 'object') {
      target.QANetworkLogger = new Internal()
    } else {
      return (
        console &&
        console.error(
          'A target must be provided to QANetworkLogger, e.g.: window'
        )
      )
    }

    return target.QANetworkLogger
  }
}

export default new QaLogger()
